























import SidebarToolbar from './SidebarToolbar.vue';

export default {
  props: {
    actions: {
      type: Array,
      default: () => ([]),
    },
    isOpen: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
    setTimeout(() => this.tuckSidebar = false, 200);
  },
  data: () => ({
    tuckSidebar: true,
  }),
  components: {
    SidebarToolbar,
  },
} as IView;
